export default __webpack_public_path__ + "d86978f7ee27b6f3bc533c48d21238c5.png";